import * as _ from 'lodash';
import { useRef } from 'react';
import type { FunctionComponent } from 'react';

import Button from '../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../generic/Button/button-constants';
import ButtonGroup from '../generic/Button/ButtonGroup';

import styles from './LogoUpload.module.less';

type Props = {
  fileUrl: string;
  setFile: (file: File) => void;
  unsetFile: () => void;
  handleImgError: () => void;
};

/**
 * Allows the user to manage and preview a logo for upload.
 */
const LogoUpload: FunctionComponent<Props> = ({ fileUrl, setFile, unsetFile, handleImgError }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.logUpload}>
      <div className={styles.logo}>
        <img src={fileUrl} onError={handleImgError} />
      </div>
      <div className={styles.options}>
        <ButtonGroup>
          <Button onClick={() => inputRef?.current?.click()} type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.MEDIUM}>
            Select Logo
          </Button>
          <Button onClick={unsetFile} type={BUTTON_TYPE.OUTLINE} size={BUTTON_SIZE.MEDIUM}>
            <div className={styles.removeLogoButtonText}>Remove Logo</div>
          </Button>
        </ButtonGroup>
        <div className={styles.recommendationText}>We recommend an SVG, PNG, or JPG of at least 512px x 512px</div>
      </div>
      <input
        type="file"
        ref={inputRef}
        accept="image/png,image/jpeg,image/svg+xml"
        onChange={(event) => {
          const file: File | undefined = _.head(event.target.files);
          if (file) {
            setFile(file);
          }
        }}
      />
    </div>
  );
};

export default LogoUpload;
